"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Hovertip = _interopRequireDefault(require("../Hovertip"));

var _style = require("./style");

var _this = void 0;

var Icontip = _Hovertip["default"].Icontip;
/**
 * ConfigInfo.Item
 * @description 配置信息项
 */

var Item = function Item(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var title = _ref.title,
      titleTip = _ref.titleTip,
      content = _ref.content,
      extra = _ref.extra,
      customTitleWidth = _ref.customTitleWidth,
      withBorder = _ref.withBorder;

  var renderTitle = function renderTitle() {
    (0, _newArrowCheck2["default"])(this, _this2);

    if (!title) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style.itemTitleCls,
      style: customTitleWidth ? {
        width: customTitleWidth
      } : {}
    }, title, titleTip && /*#__PURE__*/_react["default"].createElement(Icontip, {
      className: _style.itemTitleIconCls,
      popup: titleTip
    }));
  }.bind(this);

  return /*#__PURE__*/_react["default"].createElement(_style.StyledItem, {
    withBorder: withBorder
  }, renderTitle(), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style.itemContentWrapperCls
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style.itemContentCls
  }, content), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style.itemExtraCls
  }, extra)));
}.bind(void 0);

Item.propTypes = {
  /**
   * 配置项标题
   */
  title: _propTypes["default"].node,

  /**
   * 配置项标题的解释内容
   */
  titleTip: _propTypes["default"].node,

  /**
   * 配置项的内容
   */
  content: _propTypes["default"].node,

  /**
   * 配置项的其他信息，如操作、补充信息等
   */
  extra: _propTypes["default"].node,

  /**
   * 自定义标题的宽度
   */
  customTitleWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * 是否有下描边
   */
  withBorder: _propTypes["default"].bool
};
var _default = Item;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ConfigInfo/Item.js
// module id = 2095
// module chunks = 6 7 17 18